import { jwtDecode } from "jwt-decode";
import { getToken } from "./tokenStorage";

type JwtPayload = {
  exp: number;
  iat: number;
  sub: string;
  [key: string]: unknown;
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch {
    return true;
  }
};

export const getTokenPayload = (token: string): JwtPayload | null => {
  try {
    return jwtDecode<JwtPayload>(token);
  } catch {
    return null;
  }
};

/**
 * 사용자별 로컬 상태를 가를 키 (JWT sub).
 * 같은 WebView 에서 계정을 바꿔 로그인하면 앞 사용자의 상태가 적용되면 안 된다.
 *
 * 토큰이 없거나 sub 를 못 읽으면 null — 호출처는 저장/판정을 조용히 건너뛴다.
 *
 * ⚠️ getToken() 은 string | null 이고 getTokenPayload() 는 string 만 받는다 — null 분기 필수.
 * ⚠️ 반응형이 아니다. React 에서 구독하려면 이 값이 바뀌는 계기(로그인/로그아웃 = 라우트 이동)를
 *    별도 dep 로 잡아야 한다.
 */
export const getCurrentUserKey = (): string | null => {
  const token = getToken();
  if (!token) return null;
  return getTokenPayload(token)?.sub ?? null;
};
